import { LOGIN, LOGOUT, NEW_PASSWORD } from "./actions";

import type { CognitoUser } from "amazon-cognito-identity-js";

export interface User {
  id: string;
  name: string | null;
  email: string;
  role: string | null;
  token?: string; // Optional token property
  person_id?: string | null; // Optional person ID property
  isAgent?: boolean; // Whether user has agent permissions
  company_id?: string | null; // Company ID for non-agent users
  phone?: string | null; // Optional phone number property
  // Add other user properties as needed
}

export interface AccountState {
  isLoggedIn: boolean;
  isInitialized: boolean;
  user?: User | null;
  isNewPassword: boolean;
  userAttributes?: any; // Optional user attributes
  cognitoUser?: CognitoUser | null; // Optional CognitoUser property
}

export type Action =
  | {
      type: typeof LOGIN;
      user: User | null;
      isLoggedIn?: boolean;
      token?: string;
    }
  | {
      type: typeof LOGOUT;
    }
  | {
      type: typeof NEW_PASSWORD;
      userAttributes?: any;
      cognitoUser?: CognitoUser | null;
    };

// ==============================|| ACCOUNT REDUCER ||============================== //

const initialState: AccountState = {
  isLoggedIn: false,
  isInitialized: false,
  user: null,
  isNewPassword: false,
  userAttributes: null, // Initialize userAttributes to null
  cognitoUser: null, // Initialize cognitoUser to null
};

const accountReducer = (
  state: AccountState | undefined,
  action: Action
): AccountState => {
  if (!state) state = initialState;

  switch (action.type) {
    case LOGIN: {
      const { user, isLoggedIn, token } = action;

      return {
        ...state,
        isLoggedIn: isLoggedIn ?? true,
        isInitialized: true,
        userAttributes: null,
        user: user ? { ...user, token } : null,
        cognitoUser: null,
        isNewPassword: false,
      };
    }

    case LOGOUT:
      return {
        ...state,
        isInitialized: true,
        isLoggedIn: false,
        user: null,
        userAttributes: null,
        cognitoUser: null,
        isNewPassword: false,
      };

    case NEW_PASSWORD:
      return {
        ...state,
        isNewPassword: true,
        userAttributes: action.userAttributes,
        cognitoUser: action.cognitoUser,
      };

    default:
      return state;
  }
};

export default accountReducer;
